import { FC, useEffect } from 'react'
import { FormProvider } from 'react-hook-form'

import BrandingForm from '@/components/branding-form'
import LoadingButton from '@/components/loading-button'
import { Branding } from '@/out/branding'
import useUpdateBranding from '@/pages/settings/branding/LogoUploadCard/useUpdateBranding'
import SettingsCard from '@/components/settings-card'
import { Cog } from 'lucide-react'

type Props = {
  branding: Branding | undefined
}

const LogoUploadCard: FC<Props> = ({ branding }) => {
  const [update, { form, timer }] = useUpdateBranding()

  useEffect(() => {
    if (!branding) return

    form.setValue('name', branding.name)
    form.setValue('logo', branding.logo)
    form.setValue('color', branding.color)
  }, [branding, form])

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(update)}>
        <SettingsCard
          Icon={Cog}
          title="Brand Settings"
          description={
            <>
              Customize your organization&apos;s visual identity with a logo and brand color. These elements will be
              displayed across agent and customer applications to maintain a consistent brand experience.
            </>
          }
          sections={[<BrandingForm key="branding-form" form={form} />]}
          footer={
            <>
              <div className="text-xs text-destructive">
                {form.formState.errors.logo?.message || form.formState.errors.color?.message}
              </div>
              <LoadingButton type="submit" timer={timer} data-testid="save-changes-button">
                Save Changes
              </LoadingButton>
            </>
          }
        />
      </form>
    </FormProvider>
  )
}

export default LogoUploadCard
